import { SlideBaseAppServices } from '@src/slide/application/entry/toc/base/slide-base-app-services';
import { IEditorEditableServiceLayer } from '@src/slide/application/entry/toc/editor/base/service-layer/editable-service-layer.interface';
import { IEditorViewableServiceLayer } from '@src/slide/application/entry/toc/editor/base/service-layer/viewable-service-layer.interface';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';

/**
 * 编辑器App基类
 */
export abstract class BaseEditorAppServices extends SlideBaseAppServices implements IEditorAppServices {
    declare public viewableServiceLayer: IEditorViewableServiceLayer;
    public editableServiceLayer?: IEditorEditableServiceLayer;
}

